var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('ins',{staticClass:"adsbygoogle",style:(_vm.style),attrs:{"id":_vm.id,"data-ad-client":"ca-pub-1584834014713867","data-ad-slot":_vm.adSlot,"data-ad-format":"auto","data-full-width-responsive":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }